import React from 'react';
import { InlineWidget } from 'react-calendly';

const Booking = () => {
  return (
    <section id="booking" style={styles.section}>
      <div className="container">
        <h2 className="heading-1" style={styles.title}>Kostenloses Beratungsgespräch buchen</h2>
        <p className="body-large" style={styles.subtitle}>
          Wählen Sie einen passenden Termin für Ihr persönliches Gespräch
        </p>
        
        <div style={styles.calendlyContainer}>
          <InlineWidget
            url="https://calendly.com/nicolas-wahr"
            styles={{
              height: '700px',
              minWidth: '320px',
            }}
          />
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: 'var(--bg-page)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '16px',
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: '56px',
    color: 'var(--text-secondary)',
  },
  calendlyContainer: {
    maxWidth: '1000px',
    margin: '0 auto',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
  },
};

export default Booking;